import type { OwnerType } from './enums';
import type { ContractRole, ContractType } from '@paid-ui/enums/contract';

import { clamp, findIndex, findLastIndex } from 'lodash';
import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

import { signUpSteps } from '../constants/steps';
import { isOwner } from '../utils/is-owner';
import { SignUpStep } from './enums';

export const signUpManager = proxy({
  currentStep: SignUpStep.TYPE_AND_EMAIL,
  steps: signUpSteps,
  invitedSignUp: false,
  invitedOwnerSignUp: false,
  invitedBusinessSignUp: false,
  invitedRole: null as ContractRole | null,
  contractType: null as ContractType | null,
  partyType: null as OwnerType | null,
  userGroupId: '',
  // null until the user answers the ABN step, so the radio group starts blank.
  userDeclaredNoAbn: null as boolean | null,
});

devtools(signUpManager, {
  name: 'Sign Up',
  enabled: false,
});

export const prevStep = () => {
  const { steps, currentStep } = signUpManager;
  const prevStep = findLastIndex(
    steps,
    (step) => step.index < currentStep && !step.skip,
    currentStep,
  );
  signUpManager.currentStep = Math.max(prevStep, SignUpStep.TYPE_AND_EMAIL);
};

export const nextStep = () => {
  const { steps, currentStep } = signUpManager;
  const nextStep = findIndex(steps, (step) => step.index > currentStep && !step.skip, currentStep);
  signUpManager.currentStep = nextStep === -1 ? steps.length - 1 : Math.min(nextStep, steps.length);
};

export const goToStep = (step: SignUpStep) => {
  const { steps } = signUpManager;
  signUpManager.currentStep = clamp(step, SignUpStep.TYPE_AND_EMAIL, steps.length);
};

export const setInvitedSignUp = (options: {
  invited: boolean;
  invitedRole?: ContractRole | null;
  contractType?: ContractType | null;
  partyType?: OwnerType | null;
  groupId?: string;
}) => {
  const { invited, invitedRole, contractType, partyType, groupId } = options;
  const invitedOwnerSignUp = isOwner(invitedRole);

  signUpManager.invitedSignUp = invited;
  signUpManager.invitedOwnerSignUp = invited && invitedOwnerSignUp;
  signUpManager.invitedBusinessSignUp = invited && !invitedOwnerSignUp;
  signUpManager.invitedRole = invitedRole || null;
  signUpManager.contractType = contractType || null;
  signUpManager.partyType = partyType || null;
  signUpManager.userGroupId = groupId ?? '';
};
